<template>
  <div id="admin" v-if="isSuperUser" class="container-fluid">
    <Breadcrumb :breadcrumbs="breadcrumbs"/>
    <router-view/>
  </div>

  <NotFound v-else/>

</template>

<script>
  import NotFound from '@/components/shares/NotFound'
  import GetUser from '@/mixins/GetUser'
  import BreadcrumbMixin from '@/mixins/BreadcrumbMixin'
  import Breadcrumb from '@/components/shares/Breadcrumb'
  
  import { Filter } from '@/models/filter'

  export default {
    components: { Breadcrumb, NotFound },
    created() {
      this.loadAccountsAndUsers(false)
      this.setInterval = setInterval(this.loadAccountsAndUsers, 60000)
    },
    data: () => ({
      allAccounts: {  data: [], key: 1, load: false },
      allUsers: { data: [], key: 1, load: false },
      setInterval: null
    }),
    destroyed() {
      clearInterval(this.setInterval)
    },
    methods: {
      buildFilterAccount(accounts) {
        return this.filterAccount = new Filter({
          key: 'accountId',
          label: 'Conta',
          table: accounts.map(a => [`${a.id} - ${a.name}`, a.id])
        })
      },
      buildFilterEmail(users) {
        return new Filter({
          key: 'email',
          label: 'E-mail',
          table: users.map(e => e.email)
        })
      },
      getAccountName(entity) {
        let account = entity.account

        if (account) {
          return account.name
        } else if (entity.accountId) {
          if (!this.allAccounts.data || this.allAccounts.data.length === 0) {
            return `Conta [${entity.accountId}]`
          }
          account = this.allAccounts.data.find(a => a.id.toString() === entity.accountId.toString())
          return (account && account.name) || `Conta [${entity.accountId}]`
        }
      },
      loadAccountsAndUsers(checkHidden = true) {
        if (checkHidden && !document.hidden)
          return

        const key = 'accountAndUserInAdmin'
        const accountsAndUsers = this.$ss.get(key)
        if (accountsAndUsers)
          return this.setAccountsAndUsers(accountsAndUsers)
        
        this.axios.get('/admin/events/filter_options')
          .then(response => response.data)
          .then(data => {
            this.setAccountsAndUsers(data)
            this.saveBackup(key, data, 5)
          })
      },
      saveBackup(key, data, minutes = 1) {
        this.$ss.set(key, data, { minutes })
      },
      setAccountsAndUsers(data) {
        this.allAccounts.data = data.accounts
        this.allAccounts.load = true
        this.allAccounts.key ++
        this.allUsers.data = data.users
        this.allUsers.load = true
        this.allUsers.key ++
      },
    },
    mixins: [GetUser, BreadcrumbMixin],
    name: 'Admin',
    provide() {
      return {
        allAccounts: this.allAccounts,
        allUsers: this.allUsers,
        buildFilterAccount: this.buildFilterAccount,
        buildFilterEmail: this.buildFilterEmail,
        getAccountName: this.getAccountName
      }
    }
  }
</script>

<style scoped lang="scss">

  #admin {
    box-shadow: 0 0 0 16px gray;
    height: 100%;
    overflow-y: auto;
    padding: 4px;
  }

</style>
